import { ApolloClient } from "@apollo/client";
import { FORM_OPERATION } from "@archetypes/form";
import { FORM_DELTA } from "@queries/index";

export const formOperation = ({
  appId,
  formId,
  pageId,
  questionId,
  metadata,
  type,
  client,
  targetPageId,
  ruleId,
}: {
  appId: string;
  formId: string;
  pageId?: string;
  questionId?: string;
  ruleId?: string;
  targetPageId?: string;
  metadata?: Record<string, unknown>;
  type: FORM_OPERATION;
  client: ApolloClient<object>;
}) => {
  client
    .mutate({
      mutation: FORM_DELTA,
      variables: {
        input: {
          appId,
          formId,
          pageId,
          questionId,
          ruleId,
          ...(targetPageId && { targetPageId }),
          type,
          metadata,
        },
      },
    })
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.error(err);
    });
};
